import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode, type JSX } from 'react';
import { corePalette } from '@/themes/colours';
import CustomTypography from './Typography';

interface IProps {
  children: ReactNode;
  label?: string;
  helperText?: string;
  helperTextError?: boolean;
  helperTextPlacement?: 'above' | 'below';
  errorMessage?: string;
  sx?: SxProps<Theme>;
  required?: boolean;
}

export default function LabelledInputWrapper({
  children,
  label,
  helperText,
  helperTextError,
  helperTextPlacement = 'above',
  errorMessage,
  sx,
  required,
}: IProps): JSX.Element {
  const helperTextElement = helperText ? (
    <CustomTypography
      variant="bodySmall"
      color={helperTextError ? corePalette.red200 : corePalette.grey100}
    >
      {helperText}
    </CustomTypography>
  ) : null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={sx}
    >
      {label && (
        <Box display="flex" gap="4px">
          <CustomTypography variant="label">
            {label}
          </CustomTypography>
          {required && (
            <CustomTypography variant="label" color={corePalette.red200}>
              *
            </CustomTypography>
          )}
        </Box>
      )}
      {helperTextPlacement === 'above' && helperTextElement}
      {children}
      {helperTextPlacement === 'below' && helperTextElement}
      {errorMessage && (
        <CustomTypography
          variant="label"
          color={corePalette.red200}
        >
          {errorMessage}
        </CustomTypography>
      )}
    </Box>
  );
}
